import React from 'react';
import {} from 'components/core';
import ItemsList from './list';
import CreateDialog from './dialog';


export default function Categories({mainDialogOpen, handleDialogClose, collapsed})
{
    return <>
      <CreateDialog open={mainDialogOpen} handleClose={()=>handleDialogClose()}/>
      <ItemsList collapsed={collapsed} />
    </>
}

